import { z } from 'zod';
import { userRoleSchema } from '@/entities/user/model/userSchema';

export const sessionStatusSchema = z.enum(['active', 'revoked', 'expired']);

const SessionDataSchema = z.object({
  id: z.string().nullish(),
  user_id: z.string(),
  role: userRoleSchema,
  status: sessionStatusSchema.nullish(),
  expires_at: z.string(),
});

export const SessionSchema = z
  .object({
    session: SessionDataSchema,
  })
  .transform(({ session }) => session);

export type Session = z.infer<typeof SessionSchema>;
export type SessionApi = z.input<typeof SessionSchema>;
